export interface Link {
  title: string;
  path: string;
}

export function isLink(value: any): value is Link {
  // The type KeysEnum and constant linkKeysEnum are used to make sure that
  // every property in the Link interface is checked in this user-defined type
  // guard. There is one drawback to this type guard: it does not check if the
  // object's property values are the correct type (e.g. string vs. number). It
  // only checks that the property values are non-null.
  // Sources:
  // https://stackoverflow.com/a/54308812
  // https://2ality.com/2020/06/type-guards-assertion-functions-typescript.html#user-defined-type-guards-2
  type KeysEnum<T> = { [P in keyof Required<T>]: true };
  const linkKeysEnum: KeysEnum<Link> = { title: true, path: true };
  const linkKeys = Object.keys(linkKeysEnum);

  return value != null && linkKeys.every((key) => value[key] != null);
}
